<template>
  <section id="login">
    <b-field label="Username">
      <b-input
        required
        maxlength="50"
        placeholder="Username"
        v-model="username"
      ></b-input>
    </b-field>

    <b-field label="Password">
      <b-input
        type="password"
        placeholder="Password"
        required
        password-reveal
        v-model="password"
      ></b-input>
    </b-field>

    <b-button
      type="is-primary"
      class="mt-4"
      :loading="isLoading"
      @click="login"
    >
      Login
    </b-button>
  </section>
</template>

<script>
import { authenticate } from "@/services/sso";
export default {
  components: {},

  name: "Login",

  data() {
    return {
      isLoading: false,
      username: null,
      password: null,
    };
  },

  methods: {
    async login() {
      this.isLoading = true;
      const response = await authenticate(this.username, this.password);
      if (!response || !response.access_token) {
        this.$buefy.toast.open({
          message: "Invalid username or password!",
          type: "is-danger",
        });
        this.isLoading = false;
        return;
      }

      localStorage.setItem("accessToken", response.access_token);
      
      // Check if there's a redirect query parameter
      const redirectTo = this.$route.query.redirect;
      if (redirectTo && redirectTo !== "/login") {
        this.$router.replace(redirectTo);
      } else {
        this.$router.replace({ name: "home" });
      }
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
#login {
  background-color: white;
  width: 320px;
  min-height: 280px;
  padding: 1rem;
  margin-top: 5rem;
  margin-bottom: 10rem;
  position: relative;
  margin-left: auto;
  margin-right: auto;
}
</style>
